import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, NgForm, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ApiService } from 'src/app/api.service';
import { AppUtility } from 'src/app/interceptor/apputitlity';

@Component({
  selector: 'app-loginupline',
  templateUrl: './loginupline.component.html',
  styleUrls: ['./loginupline.component.scss']
})
export class LoginuplineComponent implements OnInit {

  constructor(private _apiService: ApiService, private fb: FormBuilder, private router: Router, private utility: AppUtility, private messageService: MessageService) { }
  userId: any = '';

  loginForm = this.fb.group({
    loginName: new FormControl('', [Validators.required]),
    password: new FormControl('', [Validators.required])
  })
  ngOnInit(): void {
  }

  loginFunction(login: NgForm) {
    if (this.loginForm.valid) {
      this.utility.loader(true);
      this._apiService.login(this.loginForm.value).then((res: any) => {
        // console.log(res);
        if (res.success) {
          this.utility.loader(false);
          localStorage.setItem('UplineUser', JSON.stringify(res.returnValue));
          localStorage.setItem('eventUser', JSON.stringify(res.returnValue));
          console.log("res", res);
          let userName = res.returnValue.loginName;
          console.log("userName", userName)
          if (userName === "Admin") {
            this.router.routeReuseStrategy.shouldReuseRoute = () => false;
            this.router.onSameUrlNavigation = 'reload';
            this.router.navigate(['/dashboard']);
          }
          else {
            this.router.routeReuseStrategy.shouldReuseRoute = () => false;
            this.router.onSameUrlNavigation = 'reload';
            this.router.navigate(['/customerBooking']);
          }
          // const upLineId = uplineUser.upLineId;
          // this.router.navigateByUrl('/dashboard');



        }
        else {
          this.utility.loader(false);
          this.messageService.add({
            severity: 'error',
            detail: res.message
          });
        }
      })
    }
  }


}
